import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track13BRed = ({ state, workState, onLabelClick }) => (
	<g id="Track13BRed" transform="translate(1752.000000, 1222.000000)" className="track">
		<g id="line" transform="translate(-0.000000, 0.566406)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M38.8248032,169.698076 L43.0215089,167.89152 C48.8013595,165.403468 54.3334637,162.375417 59.544218,158.847653 L93.2885691,136.002193 C113.337933,122.428455 124.181177,98.8360483 121.426165,74.7812519 L118.908519,52.7989727 L118.908519,52.7989727 L150.822103,0.0548342046"/>
			<line x1="3.25186874e-12" y1="184.433594" x2="29.0881149" y2="173.857318"/>
			<TrackArrow transform="translate(26.306412, 174.606946) rotate(-202.000000) translate(-26.306412, -174.606946) "
									points="30.3064118 182.606946 22.3064118 174.606946 30.3064118 166.606946"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track13BRed')}
			coords="103.154304, 33.066406"
			text="13B"
			textCoordsX="7.68554688"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track13BRed.propTypes = trackPropTypes;

export default Track13BRed;
